import * as React from 'react';
import { IconProps } from '../types';

const IcResolution = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none' {...props}>
    <path
      d='M11.6667 14.1668H15.8334V10.0002H14.1667V12.5002H11.6667V14.1668ZM4.16675 10.0002H5.83341V7.50016H8.33341V5.8335H4.16675V10.0002ZM3.33341 16.6668C2.87508 16.6668 2.48272 16.5036 2.15633 16.1772C1.82994 15.8509 1.66675 15.4585 1.66675 15.0002V5.00016C1.66675 4.54183 1.82994 4.14947 2.15633 3.82308C2.48272 3.49669 2.87508 3.3335 3.33341 3.3335H16.6667C17.1251 3.3335 17.5174 3.49669 17.8438 3.82308C18.1702 4.14947 18.3334 4.54183 18.3334 5.00016V15.0002C18.3334 15.4585 18.1702 15.8509 17.8438 16.1772C17.5174 16.5036 17.1251 16.6668 16.6667 16.6668H3.33341ZM3.33341 15.0002H16.6667V5.00016H3.33341V15.0002Z'
      fill={props?.fill ?? '#434655'}
    />
  </svg>
);

export default IcResolution;
